<template>
  <section class="p5">
    <div class="container">
      <div class="faq-main-subheader">
        <img src="/img/faq-icon-min.gif" alt="" />
        <h1>HelixPay FAQs</h1>
      </div>

      <div
        id="accordionFlushExample"
        class="accordion accordion-flush m-auto py-5"
      >
        <!-- Item 1 -->
        <div class="accordion-item">
          <h2 id="flush-headingOne" class="accordion-header">
            <button
              class="accordion-button collapsed fw-bold bg-white"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseOne"
            >
              What is HelixPay?
            </button>
          </h2>
          <div
            id="flush-collapseOne"
            class="accordion-collapse collapse"
            aria-labelledby="flush-headingOne"
            data-bs-parent="#accordionFlushExample"
          >
            <div class="accordion-body fw-semibold opacity-50">
              HelixPay is the first Subscription Management platform for
              businesses, organizations, and content creators in the
              Philippines. With HelixPay, you can offer, manage, and optimize
              subscriptions and recurring payment collections. HelixPay
              technology is built to make the experience for merchants and their
              customers as seamless as possible.
            </div>
          </div>
        </div>
        <!-- Item 2 -->
        <div class="accordion-item">
          <h2 id="flush-headingOne" class="accordion-header">
            <button
              class="accordion-button collapsed fw-bold bg-white"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseTwo"
            >
              Who is HelixPay made for?
            </button>
          </h2>
          <div
            id="flush-collapseTwo"
            class="accordion-collapse collapse"
            aria-labelledby="flush-headingOne"
            data-bs-parent="#accordionFlushExample"
          >
            <div class="accordion-body fw-semibold opacity-50">
              HelixPay is built for any business, organization, or content
              creator that has recurring clients, members or fans and wants to
              enable a subscription or membership business model. For example,
              our clients include recurring service businesses like property
              managers,insurance companies, and newspapers; memberships like gym
              and professional organization memberships; and content creator fan
              subscriptions like streamers, lifestyle influencers, and
              musicians.
              <br />
              <br />
              We are built for the Philippines and currently our clients must
              have Philippines legal documents. We can however handle payments
              from your overseas customers. We plan to expand outside the
              Philippines in the near future.
            </div>
          </div>
        </div>
        <!-- Item 3 -->
        <div class="accordion-item">
          <h2 id="flush-headingOne" class="accordion-header">
            <button
              class="accordion-button collapsed fw-bold bg-white"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseThree"
            >
              Why should I use HelixPay?
            </button>
          </h2>
          <div
            id="flush-collapseThree"
            class="accordion-collapse collapse"
            aria-labelledby="flush-headingOne"
            data-bs-parent="#accordionFlushExample"
          >
            <div class="accordion-body fw-semibold opacity-50">
              HelixPay is the first and only platform in the Philippines
              designed for recurring payments, memberships, and subscriptions.
              Automated payments and efficient collections help businesses
              optimize their recurring revenue retention, customer lifetime
              value, and long-term revenue growth. HelixPay makes it easy for
              you to offer a seamless recurring payments experience with a
              well-designed user interface, powerful business management tools,
              and convenient reminders and notifications.
              <br />
              <br />
              With HelixPay, businesses can offer all the popular local payment
              options to their customers for subscriptions and recurring
              payments including card payments, Gcash, GrabPay, Paymaya, and
              Bank Transfers.
            </div>
          </div>
        </div>
        <!-- Item 4 -->
        <div class="accordion-item">
          <h2 id="flush-headingOne" class="accordion-header">
            <button
              class="accordion-button collapsed fw-bold bg-white"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseFour"
            >
              What is a HelixPay Storefront?
            </button>
          </h2>
          <div
            id="flush-collapseFour"
            class="accordion-collapse collapse"
            aria-labelledby="flush-headingOne"
            data-bs-parent="#accordionFlushExample"
          >
            <div class="accordion-body fw-semibold opacity-50">
              HelixPay makes it easy to launch a subscription webstore with no
              coding required. You can think of HelixPay similar to Shopify but
              optimized for memberships, subscriptions, and any recurring
              revenue businesses (property rentals, insurance payments, gym
              memberships).
              <br />
              <br />
              HelixPay Storefront lets you fully customize the colors, look and
              feel of your subscription or membership webstore. It is a mobile
              friendly website that you can link to your existing website and
              easily share on any social media or chat apps.
            </div>
          </div>
        </div>
        <!-- Item 5 -->
        <div class="accordion-item">
          <h2 id="flush-headingOne" class="accordion-header">
            <button
              class="accordion-button collapsed fw-bold bg-white"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseFive"
            >
              What if I have my own website already?
            </button>
          </h2>
          <div
            id="flush-collapseFive"
            class="accordion-collapse collapse"
            aria-labelledby="flush-headingOne"
            data-bs-parent="#accordionFlushExample"
          >
            <div class="accordion-body fw-semibold opacity-50">
              You can still use our no-code Storefront tool if you have an
              existing website. Many clients create a simple button on their
              existing website that automatically opens up your HelixPay
              Subscription Storefront. You can even customize the URL of the
              HelixPay Storefront to match your existing website domain.
              <br />
              <br />
              If you want to fully integrate into you website, you can use our
              <span
                style="cursor: pointer"
                onclick="window.open('https://helixpay.readme.io/reference/introduction')"
              >
                <i class="fw-bold">API integration.</i>
              </span>
            </div>
          </div>
        </div>
        <!-- Item 6 -->
        <div class="accordion-item">
          <h2 id="flush-headingOne" class="accordion-header">
            <button
              class="accordion-button collapsed fw-bold bg-white"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseSix"
            >
              What are the different options to integrate with HelixPay?
            </button>
          </h2>
          <div
            id="flush-collapseSix"
            class="accordion-collapse collapse"
            aria-labelledby="flush-headingOne"
            data-bs-parent="#accordionFlushExample"
          >
            <div class="accordion-body fw-semibold opacity-50">
              There are 3 different options to integrate with HelixPay.
              <br />
              <br />
              HelixPay No-code Storefront:<br />
              HelixPay makes it easy for businesses to set up their website and
              start offering subscriptions with zero coding required. This is
              our most popular option and the Helix pay team is available to
              help you set it up.
              <br />
              <br />
              Check out some of our storefronts here:<br />
              <br />
              <span
                style="cursor: pointer"
                onclick="window.open('https://pawssionproject.helixpay.ph/')"
              >
                <i class="fw-bold">• Pawssion Project</i>
              </span>
              <br />
              <span
                style="cursor: pointer"
                onclick="window.open('https://caulibabeclub.helixpay.ph/')"
              >
                <i class="fw-bold">• Caulibabe Club</i>
              </span>
              <br />
              <br />
              Shopify Integration:<br />
              <br />
              For the first time in the Philippines, businesses can offer
              subscriptions directly to their existing Shopify website. HelixPay
              will do the integration for you so there’s no need to hire a
              Shopify developer! Check out some of our merchants using Shopify
              here:<br />
              <br />
              <span
                style="cursor: pointer"
                onclick="window.open('https://nalawoman.ph/collections/subscribe-save-5')"
              >
                <i class="fw-bold">• Nala Woman</i>
              </span>
              <br />
              <span
                style="cursor: pointer"
                onclick="window.open('https://store.yardstickcoffee.com/collections/subscriptions')"
              >
                <i class="fw-bold">• Yardstick</i>
              </span>
              <br />
              <br />
              API Integration:<br />
              <br />
              API integration is also available for merchants who want to
              integrate directly into their existing website. Our API
              documentation is available
              <span
                class="fw-bold"
                style="cursor: pointer"
                onclick="window.open('https://helixpay.readme.io/reference/introduction')"
              >
                here.
              </span>
              This will require development time on your end but the HelixPay
              team is ready to help anytime!
              <br />
              <br />
              Note: Using another e-commerce platform? Chat with our team
              <span
                class="fw-bold"
                style="cursor: pointer"
                onclick="window.open('https://www.messenger.com/t/101830572099617/?messaging_source=source%3Apages%3Amessage_shortlink&source_id=1441792')"
              >
                here.
              </span>
            </div>
          </div>
        </div>
        <!-- Item 7 -->
        <div class="accordion-item">
          <h2 id="flush-headingOne" class="accordion-header">
            <button
              class="accordion-button collapsed fw-bold bg-white"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseSeven"
            >
              Are there any installation costs if I start to use HelixPay?
            </button>
          </h2>
          <div
            id="flush-collapseSeven"
            class="accordion-collapse collapse"
            aria-labelledby="flush-headingOne"
            data-bs-parent="#accordionFlushExample"
          >
            <div class="accordion-body fw-semibold opacity-50">
              No, there is absolutely no installation cost, start-up cost, or
              lock-in period to start using HelixPay.
            </div>
          </div>
        </div>
        <!-- Item 8 -->
        <div class="accordion-item">
          <h2 id="flush-headingOne" class="accordion-header">
            <button
              class="accordion-button collapsed fw-bold bg-white"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseEight"
            >
              How can I get verified to start using HelixPay?
            </button>
          </h2>
          <div
            id="flush-collapseEight"
            class="accordion-collapse collapse"
            aria-labelledby="flush-headingOne"
            data-bs-parent="#accordionFlushExample"
          >
            <div class="accordion-body fw-semibold opacity-50">
              You can get verified once you submit their KYC Documents and
              HelixPay Team approves it. In general, you can fully launch
              HelixPay within the same day.
            </div>
          </div>
        </div>
        <!-- Item 9 -->
        <div class="accordion-item">
          <h2 id="flush-headingOne" class="accordion-header">
            <button
              class="accordion-button collapsed fw-bold bg-white"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseNine"
            >
              What are the payment methods available for recurring payments
              through HelixPay?
            </button>
          </h2>
          <div
            id="flush-collapseNine"
            class="accordion-collapse collapse"
            aria-labelledby="flush-headingOne"
            data-bs-parent="#accordionFlushExample"
          >
            <div class="accordion-body fw-semibold opacity-50">
              Businesses using HelixPay will be able to use Credit cards, Debit
              cards, GCash, Paymaya, Grabpay, and Bank transfers with all major
              banks including BDO, BPI, Unionbank, RCBC, PNB, and more.
            </div>
          </div>
        </div>
        <!-- Item 10 -->
        <div class="accordion-item">
          <h2 id="flush-headingOne" class="accordion-header">
            <button
              class="accordion-button collapsed fw-bold bg-white"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapse10"
            >
              How much does HelixPay Charge?
            </button>
          </h2>
          <div
            id="flush-collapse10"
            class="accordion-collapse collapse"
            aria-labelledby="flush-headingOne"
            data-bs-parent="#accordionFlushExample"
          >
            <div class="accordion-body fw-semibold opacity-50">
              HelixPay charges a simple percentage fee for your transactions
              handled by HelixPay. We help get you the lowest possible rates
              from our payment processing partners and then only charge a simple
              percentage fee for access to the entire HelixPay system. You can
              view our full pricing details here.
            </div>
          </div>
        </div>
        <!-- Item 11 -->
        <div class="accordion-item">
          <h2 id="flush-headingOne" class="accordion-header">
            <button
              class="accordion-button collapsed fw-bold bg-white"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapse11"
            >
              How can I manage my customers’ subscriptions and recurring orders
              using HelixPay?
            </button>
          </h2>
          <div
            id="flush-collapse11"
            class="accordion-collapse collapse"
            aria-labelledby="flush-headingOne"
            data-bs-parent="#accordionFlushExample"
          >
            <div class="accordion-body fw-semibold opacity-50">
              HelixPay merchants have access to their business dashboard to
              manage their client’s subscriptions, orders, and payments. All the
              information displayed on the dashboard is updated in real-time!
              You can check our guide to the HelixPay console
              <span
                class="fw-bold"
                style="cursor: pointer"
                onclick="window.open('https://helixpay-console.readme.io/docs/overview')"
              >
                here.
              </span>
            </div>
          </div>
        </div>
        <!-- Item 12 -->
        <div class="accordion-item">
          <h2 id="flush-headingOne" class="accordion-header">
            <button
              class="accordion-button collapsed fw-bold bg-white"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapse12"
            >
              What are the frequencies/recurrences that I can offer to my
              customers?
            </button>
          </h2>
          <div
            id="flush-collapse12"
            class="accordion-collapse collapse"
            aria-labelledby="flush-headingOne"
            data-bs-parent="#accordionFlushExample"
          >
            <div class="accordion-body fw-semibold opacity-50">
              HelixPay’s available frequencies are weekly, every other week,
              monthly, quarterly, and annual. You can also set custom pricing
              discounts for quarterly and annual payments.
            </div>
          </div>
        </div>
        <!-- Item 13 -->
        <div class="accordion-item">
          <h2 id="flush-headingOne" class="accordion-header">
            <button
              class="accordion-button collapsed fw-bold bg-white"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapse13"
            >
              Can my customers change their mode of payment during the duration
              of their subscription?
            </button>
          </h2>
          <div
            id="flush-collapse13"
            class="accordion-collapse collapse"
            aria-labelledby="flush-headingOne"
            data-bs-parent="#accordionFlushExample"
          >
            <div class="accordion-body fw-semibold opacity-50">
              Yes, customers can change their mode of payment for every order
              without breaking or disrupting their subscription.
            </div>
          </div>
        </div>
        <!-- Item 14 -->
        <div class="accordion-item">
          <h2 id="flush-headingOne" class="accordion-header">
            <button
              class="accordion-button collapsed fw-bold bg-white"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapse14"
            >
              Can my customers change their order during the duration of their
              subscription?
            </button>
          </h2>
          <div
            id="flush-collapse14"
            class="accordion-collapse collapse"
            aria-labelledby="flush-headingOne"
            data-bs-parent="#accordionFlushExample"
          >
            <div class="accordion-body fw-semibold opacity-50">
              Yes, HelixPay makes it easy for customers to manage their
              subscriptions through their subscriber portal. Learn more about
              the subscriber portal here.
            </div>
          </div>
        </div>
        <!-- Item 15 -->
        <div class="accordion-item">
          <h2 id="flush-headingOne" class="accordion-header">
            <button
              class="accordion-button collapsed fw-bold bg-white"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapse15"
            >
              How can I migrate my current subscriptions to HelixPay?
            </button>
          </h2>
          <div
            id="flush-collapse15"
            class="accordion-collapse collapse"
            aria-labelledby="flush-headingOne"
            data-bs-parent="#accordionFlushExample"
          >
            <div class="accordion-body fw-semibold opacity-50">
              Merchants can upload customers and subscriptions directly on the
              HelixPay dashboard. Doing this will automatically send email and
              SMS notifications to those customers inviting them to pay. In case
              you need to upload a larger list of clients, please contact your
              HelixPay Account Manager and they will set it up for you.
            </div>
          </div>
        </div>
        <!-- Item 16 -->
        <div class="accordion-item">
          <h2 id="flush-headingOne" class="accordion-header">
            <button
              class="accordion-button collapsed fw-bold bg-white"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapse16"
            >
              Can HelixPay process single purchase orders with transactions?
            </button>
          </h2>
          <div
            id="flush-collapse16"
            class="accordion-collapse collapse"
            aria-labelledby="flush-headingOne"
            data-bs-parent="#accordionFlushExample"
          >
            <div class="accordion-body fw-semibold opacity-50">
              Yes. HelixPay can process single purchase transactions and
              transactions with both single purchase and subscription options.
            </div>
          </div>
        </div>
        <!-- Item 17 -->
        <div class="accordion-item">
          <h2 id="flush-headingOne" class="accordion-header">
            <button
              class="accordion-button collapsed fw-bold bg-white"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapse17"
            >
              What if I’m not a corporation?
            </button>
          </h2>
          <div
            id="flush-collapse17"
            class="accordion-collapse collapse"
            aria-labelledby="flush-headingOne"
            data-bs-parent="#accordionFlushExample"
          >
            <div class="accordion-body fw-semibold opacity-50">
              This is totally fine! We work with a lot of organizations,
              freelancers, and independent content creators as well and you are
              able to use HelixPay with all the functionality as an individual.
            </div>
          </div>
        </div>
        <!-- Item 18 -->
        <div class="accordion-item">
          <h2 id="flush-headingOne" class="accordion-header">
            <button
              class="accordion-button collapsed fw-bold bg-white"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapse18"
            >
              How can I communicate with my subscribers?
            </button>
          </h2>
          <div
            id="flush-collapse18"
            class="accordion-collapse collapse"
            aria-labelledby="flush-headingOne"
            data-bs-parent="#accordionFlushExample"
          >
            <div class="accordion-body fw-semibold opacity-50">
              HelixPay has built a powerful subscriber engagement system that is
              included in your account. You can send “blast” announcements to
              your subscribers that are delivered via email (SMS and Viber
              coming soon). These can announce new product offerings, special
              marketing activities, or any other news you would like to share.
              These blasts can be sent to all your subscribers or even segmented
              for different customer groups.
            </div>
          </div>
        </div>
        <!-- Item 19 -->
        <div class="accordion-item">
          <h2 id="flush-headingOne" class="accordion-header">
            <button
              class="accordion-button collapsed fw-bold bg-white"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapse19"
            >
              Do you charge extra for your notification tools?
            </button>
          </h2>
          <div
            id="flush-collapse19"
            class="accordion-collapse collapse"
            aria-labelledby="flush-headingOne"
            data-bs-parent="#accordionFlushExample"
          >
            <div class="accordion-body fw-semibold opacity-50">
              Nope! HelixPay notification tools are included in your account
              including email, SMS, and viber notification tools for both the
              merchant account and the subscribers.
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      layout: 'All',
    };
  },
};
</script>

<style scoped>
* {
  line-height: 1.7;
}

.accordion-header:focus,
.accordion-header button:focus {
  box-shadow: none;
}

.accordion-body {
  line-height: 2;
}

.container,
section {
  width: 100%;
}

.faq-main-subheader {
  width: 28%;
  display: flex;
  margin: auto;
  justify-content: center;
  align-items: center;
  gap: 1rem;
}

.faq-main-subheader img {
  width: 40px;
  height: 40px;
}

.faq-main-subheader h1 {
  font-size: 2rem;
}

.accordion-item button {
  color: black;
}

.accordion-item button:focus {
  color: #25a4e1;
}

.accordion {
  width: 71rem;
}

@media screen and (max-width: 1400px) {
  .accordion {
    width: 60rem;
  }

  .faq-main-subheader {
    width: 40rem;
  }
}

@media screen and (max-width: 1050px) {
  .accordion {
    width: 40rem;
  }
}

@media screen and (max-width: 900px) {
  .accordion,
  .faq-main-subheader {
    width: 90%;
  }
}

@media screen and (max-width: 650px) {
  .faq-main-subheader img {
    width: 40px;
    height: 40px;
  }

  .faq-main-subheader h1 {
    font-size: 1.3rem;
  }

  .container {
    width: 100%;
  }

  .accordion {
    width: 100%;
  }
}
</style>
